export type TCreatedFrom = "web_service" | "web_app";

export function normalizeCreatedFrom(createdFrom?: string | null): TCreatedFrom {
	const value = String(createdFrom ?? "").toLowerCase();
	if (value === "web_service") return "web_service";
	return "web_app";
}

export function translateCreatedFrom(createdFrom?: string | null): string {
	return normalizeCreatedFrom(createdFrom) === "web_service" ? "Integração" : "Aplicação";
}

export function translateDocumentType(traduzir: String) {
	if (traduzir === "client_contract") {
		return "Contratos de serviços";
	}
	if (traduzir === "client_adictive") {
		return "Aditivos de contratos";
	}

	if (traduzir === "client_documents" || traduzir === "client") {
		return "Outros";
	}

	return traduzir;
}
